import { AppAndroidProvider, AppBrowserProvider, AppIosProvider } from "@kiddocare-platform/portal-common/contexts";
import { useLogger } from "@kiddocare-platform/portal-common/helpers";
import { KiddocareProvider, Prompt, Toaster } from "@kiddocare-platform/portal-common/ui";
import React, { useMemo } from "react";
import { AdminContextProvider } from "./contexts/admin.context";
import { PagesRoutes } from "./pages/pages.routes";

export const App: React.FC = () => {
  const log = useLogger(App.name);

  const AppProvider = useMemo(() => {
    const iosKiddocareBridge: any = (window as any).iosKiddocareBridge;
    const androidKiddocareBridge: any = (window as any).androidKiddocareBridge;

    let AppProvider = undefined;
    if (iosKiddocareBridge) {
      log.info("Detected iosKiddocareBridge, instance AppIosProvicer");
      AppProvider = AppIosProvider;
    }
    else if (androidKiddocareBridge) {
      log.info("Detected androidKiddocareBridge, instance AppAndroidProvider");
      AppProvider = AppAndroidProvider;
    }
    else {
      log.info("instance AppBrowserProvider");
      AppProvider = AppBrowserProvider;
    }
    return AppProvider;
  }, []);

  return (
    <AppProvider>
      <AdminContextProvider>
        <KiddocareProvider>
          <PagesRoutes />
          <Toaster />
          <Prompt />
        </KiddocareProvider>
      </AdminContextProvider>
    </AppProvider>
  );
}



/*import { KiddocareProvider } from "./components/layout/provide.component";
import { Prompt } from "./components/prompt.component";
import { Toaster } from "./components/toaster.component";
import { AppAndroidProvider } from "./contexts/app-android.context";
import { AppBrowserProvider } from "./contexts/app-browser.context";
import { AppIosProvider } from "./contexts/app-ios.context";
import { useLogger } from "./helpers/logger.helper";
import { PagesRoutes } from "./pages/pages.routes";

const App: React.FC = () => {
  const log = useLogger(App.name);

  const iosKiddocareBridge: any = (window as any).iosKiddocareBridge;
  const androidKiddocareBridge: any = (window as any).androidKiddocareBridge;

  let AppProvider = undefined;
  if (iosKiddocareBridge) { AppProvider = AppIosProvider; }
  else if (androidKiddocareBridge) { AppProvider = AppAndroidProvider; }
  else { AppProvider = AppBrowserProvider; }

  if (!AppProvider) {
    log.error("No AppProvider found. Please check the environment.");
    return <div>Error: No AppProvider found.</div>;
  }

  return (
    <AppProvider>
      <KiddocareProvider>
        <PagesRoutes />
        <Toaster />
        <Prompt />
      </KiddocareProvider>
    </AppProvider>
  )
}

export { App };*/



/*import { Box, Flex } from '@chakra-ui/react';
import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuthContext } from './contexts/auth.context';
import { ServiceProvider } from './contexts/service.context';
import { MainBarLayout } from './layouts/main-bar.layout';

const AuthPage = React.lazy(() => import('./pages/auth/auth.page'));
const AuthCallbackPage = React.lazy(() => import('./pages/auth/callback.page'));
const AuthLoginPage = React.lazy(() => import('./pages/auth/login.page'));
const AuthLogoutPage = React.lazy(() => import('./pages/auth/logout.page'));
const AuthPostLogoutPage = React.lazy(() => import('./pages/auth/postlogout.page'));

const DashboardPage = React.lazy(() => import('./pages/home/dashboard.page'));
const PediatriciansPage = React.lazy(() => import('./pages/pediatricians/pediatricians.page'));
const PediatriciansDetailPage = React.lazy(() => import('./pages/pediatricians/detail.page'));
const PediatricianCardPage = React.lazy(() => import('./pages/pediatricians/card.page'));
const PediatriciansCertificatesPage = React.lazy(() => import('./pages/pediatricians/certificates.page'));
const PediatriciansBillingsPage = React.lazy(() => import('./pages/pediatricians/billings.page'));
const PediatricianPatientsPage = React.lazy(() => import('./pages/pediatricians/patients.page'));
const BillingPage = React.lazy(() => import('./pages/billing/billing.page'));
const BillingSubscriptionPage = React.lazy(() => import('./pages/billing/subscriptions.page'));

const ProfileInfoPage = React.lazy(() => import('./pages/profile/info.page'));

const PlatformOrbitPage = React.lazy(() => import('./pages/platform/orbit/orbit.page'));
const PlatformOrbitFlowPage = React.lazy(() => import('./pages/platform/orbit/flow.page'));
const PlatformOrbitQueuePage = React.lazy(() => import('./pages/platform/orbit/queue.page'));
const PlatformOrbitQueuesPage = React.lazy(() => import('./pages/platform/orbit/queues.page'));

export default function App() {
  const { User } = useAuthContext();
  return (
    <Suspense fallback={<div>Caricamento...</div>}>
      <Routes>
        <Route path="/auth/*" element={
          <Routes>
            <Route path="/" element={<AuthPage />}>
              <Route path="login" element={<AuthLoginPage />} />
              <Route path="logout" element={<AuthLogoutPage />} />
              <Route path="callback" element={<AuthCallbackPage />} />
              <Route path="postlogout" element={<AuthPostLogoutPage />} />
              <Route path="/" element={<Navigate to="login" replace />} />
            </Route>
          </Routes>
        } />
        <Route path="/*" element={(
          User ? (
            <ServiceProvider>
              <Flex direction={{ base: 'column', md: 'row' }} height="100vh" overflow={'auto'} >
                <MainBarLayout />
                <Box flexGrow={1}>
                  <Routes>
                    <Route path="dashboard" element={<DashboardPage />} />
                    <Route path="pediatricians" element={<PediatriciansPage />} />
                    <Route path="pediatricians/detail/:id" element={<PediatriciansDetailPage />}>
                      <Route path="" element={<PediatricianCardPage />} />
                      <Route path="certificates" element={<PediatriciansCertificatesPage />} />
                      <Route path="billings" element={<PediatriciansBillingsPage />} />
                      <Route path="patients" element={<PediatricianPatientsPage />} />
                    </Route>
                    <Route path="/billing" element={<BillingPage />} >
                      <Route path="subscriptions" element={<BillingSubscriptionPage />} />
                    </Route>
                    <Route path='/platform/orbit' element={<PlatformOrbitPage />}>
                      <Route path="flow" element={<PlatformOrbitFlowPage />} />
                      <Route path="queue/:queue" element={<PlatformOrbitQueuePage />} />
                      <Route path="queues" element={<PlatformOrbitQueuesPage />} />
                      <Route index element={<Navigate to="queues" replace />} />
                    </Route>
                    <Route path="/profile" element={<ProfileInfoPage />} />

                    <Route path="/" element={<Navigate to="dashboard" replace />} />
                    <Route path="*" element={<h1>404 - Pagina non trovata</h1>} />
                  </Routes>
                </Box>
              </Flex>
            </ServiceProvider>
          ) : (
            <Navigate to="/auth" replace />
          )
        )}
        />
      </Routes>
    </Suspense>
  );
}
*/